<template>
    <div v-if="settings">
        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Integration Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.integrationKey" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sys id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.sysId" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Tid</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.tid" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Security key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.securityKey" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.widgetUrl" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Lobby Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input v-model="settings.lobbyUrl" class="input oc-input" type="text" />
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="saveSettingsAsync();" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lottoService from "../../../../services/doubleChanceLotto.service";

    export default {
        name: "client-settings-doublechancelotto",
        data: () => ({ settings: null }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            this.loadSettingsAsync();
        },
        methods: {
            async loadSettingsAsync() {
                this.settings = await lottoService.getSettingsAsync(this.clientId);
            },
            async saveSettingsAsync() {
                return await lottoService.saveSettingsAsync(this.clientId, this.settings);
            }
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/doublechancelotto.vue